<template>
  <div >
    <a-back-top />
    <a-row>
      <a-col :md="24">
        <div class="allbody" :style="{transform : `scale(${scaleW},${scaleH})`}">
<!--          <div style="float: left;margin-top: 1%;margin-left: 10%">
            <img src="~@/assets/imgs/logo1.png" width="40">
          </div>-->
          <div style="margin-top: 1%;float: right;margin-right: 15%;">
            <router-link to='/'><a>首页</a></router-link>
            <router-link to='/productintr'><a>产品介绍</a></router-link>
            <router-link to='/aboutus'><a style="font-weight: bold;">关于我们</a></router-link>
            <router-link to='/caseinfo'><a>业绩案例</a></router-link>
            <router-link to='/contantus'><a-button shape="round">联系我们</a-button></router-link>
          </div>
          <div class="contant">
            <p style="color: rgba(255, 255, 255, 100);font-size: 38px;font-weight: bold">
              <span>关于我们</span>
            </p>
            <p style="color: rgba(255, 255, 255, 100);font-size: 16px;">
              <span> 南京汇钧云合科技有限公司聚焦城市智能管理等领域，提供相关产品与服务方案。</span>
            </p>
          </div>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="text-align: center;margin-top: 5%;margin-bottom: 5%;">
          <img src="~@/assets/imgs/aboultus.png" style="height:350px;margin-bottom: 20px;">
          <div>
            <h3>南京汇钧云合科技有限公司</h3>
            <div style="color: #6D7783;font-family: SourceHanSansSC-regular;font-size: 14px;padding: 0px 23%">南京汇钧云合科技有限公司聚焦城市智能管理等领域，提供相关产品与服务方案。
              公司总部位于南京，并在多地开展业务服务。公司集研发、生产、销售与服务于一体，持续投入物联网、云计算、智能终端等方向的技术研发，
              基于复合识别、边缘计算、数据分析等技术，为业务管理和决策提供技术支持。
            </div>
          </div>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="height: 300px;background-color: #ecf5ff;text-align: center">
          <div style="color:#222A41;font-size: 24px;font-weight: bold;padding: 5% 0px">我们的团队</div>
          <div style="color: #6D7783;font-family: SourceHanSansSC-regular;font-size: 14px;padding: 0px 23%">
            公司拥有由行业顾问与研发工程师组成的技术团队，围绕镜面云码、电梯中台技术、电梯安全云、电梯物联网设备、气瓶充装管理系统、
            特种设备检验检测信息化平台等方向开展研发与服务，面向政府部门、生产企业、维保企业、使用单位及系统建设方提供相关技术支持。
          </div>
        </div>
      </a-col>
      <a-col :md="24">
        <foot-boot1 />
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import footBoot1 from './footboot1'
  export default {
    name: 'Website',
    components: {
      footBoot1
    },
    data () {
      return {
        scaleW: 1,
        scaleH: 1,
        size:50,
        tabBarGutter:100
      }
    },
    created(){

    },
    methods: {
      callback(key) {
        console.log(key);
      },
    }
  }
</script>
<style>
  .anchorBL {
    display: none;
  }
  .BMap_cpyCtrl .BMap_noprint .anchorBL {
    display: none;
  }
</style>
<style scoped>
  a{
    white-space: nowrap;
    color: black;
    font-family: SourceHanSansSC-regular;
    margin-right: 5%;
  }
  a:hover{
    color: black;
    font-weight: bold;
  }
  .allbody{
    width: 100%;
    transform-origin: left top;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
  }
  .allbody img{
    width: 140px;
    height: 30px;
  }
  .contant{
    height: 300px;
    background-color: #3B43F2;
    margin-top: 4%;
    text-align: center;
    padding-top: 6%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Aboutus.vue